import actions from './actions'

const initialState = {
  agentPayments: { loading: false, data: null },
  agentPayment: { loading: false, data: null },
}

export default function transactionsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return {
        ...state,
        agentPayments: {
          ...state.agentPayments,
          ...action.payload.agentPayments,
        },
        agentPayment: {
          ...state.agentPayment,
          ...action.payload.agentPayment,
        },
      }
    default:
      return state
  }
}
